import React from "react";
import { Media, Container, Row, Col } from "reactstrap";
import OpenFileLink from "../Components/OpenFileLink";
import { joinCss } from "../helpers/utils";
import LinesEllipsis from "react-lines-ellipsis";

import appClasses from "../App.module.scss";
import classes from "./publication.module.scss";

import pubLogo from "../images/cubeLogo.png";

const publication = props => {
  return (
    <Container
      key={props.data.id}
      className={joinCss(
        props.componentClass,
        classes.cube,
        appClasses["center-div"]
      )}
    >
      <Row>
        <Col>
          <Media
            object
            className={classes.publicationCubeLogo}
            src={pubLogo}
            alt="פרסום"
          />
        </Col>
      </Row>
      <Row>
        <Col className={classes.pubName}>
          <LinesEllipsis text={props.data.docDescription} />
        </Col>
      </Row>
      <Row>
        <Col sm="12">
          <OpenFileLink
            localClass={appClasses["center-div"]}
            contant={props.data.pdfName}
            numOfLines="1"
            id={props.data.id}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default publication;
